import { DefaultPageState } from "../../../common/models/StoreDefaultModel";

/**
 * The two entry points of the feature: the container park lists the container
 * gate-outs, the warehouse lists the goods removals.
 */
export type RemovalType = "CONTAINER" | "GOODS";

/**
 * One line of GET /exit_notes/pending_removals: a removal of the chosen customer
 * made on the chosen day and not yet attached to an exit note.
 */
export type PendingRemovalData = {
  "@id"?: string;
  "@type"?: string;
  /** IRI to send back in ExitNote::removals. */
  removal?: string;
  reference?: string;
  removalType?: string;
  /** Conteneur / Sac / Véhicule / Divers. */
  loadType?: string | null;
  identifier?: string | null;
  designation?: string | null;
  sealNumber?: string | null;
  tonnage?: string | null;
  blNumber?: string | null;
  vessel?: string | null;
  callDate?: string | null;
  /** Nom du magasin, ou TP pour un enlèvement direct. */
  exitPoint?: string | null;
  bagCount?: number | null;
  invoiceNumber?: string | null;
  observation?: string | null;
  truckNumber?: string | null;
  driverName?: string | null;
  forwarderAgentName?: string | null;
  carrierName?: string | null;
  directRemoval?: boolean;
  exitAt?: string | null;
};

/**
 * One line of GET /exit_notes, as serialized by the 'exitNote:list' group.
 */
export type ReleaseOrderItemData = {
  "@id"?: string;
  "@type"?: string;
  id?: number;
  reference?: string;
  customer?: { id?: number; name?: string } | null;
  exitDate?: string;
  state?: { id?: string; name?: string } | null;
  removalType?: { id?: string; name?: string } | null;
  generatedBy?: { id?: number; fullname?: string; email?: string } | null;
  cancelledAt?: string | null;
  cancelledBy?: { id?: number; fullname?: string } | null;
  cancelReason?: string | null;
  createdAt?: string;
  removalCount?: number;
  containerCount?: number;
  goodsRemovalCount?: number;
};

export type CreateReleaseOrderPayload = {
  /** IRI of the customer, e.g. "/api/customers/10049". */
  customer: string;
  /** YYYY-MM-DD. */
  exitDate: string;
  /** IRIs of the selected removals. */
  removals: string[];
};

export const initialReleaseOrderPageState: DefaultPageState = {
  page: 1,
  itemsPerPage: 10,
  pagination: true,
};
